import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function PrivacyPolicy() {
  return (
    <div>
      <nav
        style={{ marginTop: "1em" }}
        className="darkNav"
        aria-label="You are here:"
        role="navigation"
      >
        <ul class="breadcrumbs">
          <li>
            <Link to="/" style={{ color: "pink" }}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/privacy-policy" style={{ color: "pink" }}>
              Privacy Policy
            </Link>
          </li>
          <li>
            <span class="show-for-sr">Current: Privacy Policy</span>
          </li>
        </ul>
      </nav>
      <div
        className="centered shadowed"
        style={{
          position: "relative",
        }}
      >
        <div>
          <h1>Jiva's Originals Privacy Policy</h1>
          <h2>Last updated April 3, 2023</h2>
          <br></br>
          <h2>INTRODUCTION</h2>
          <div>
            <p>
              Jiva's Originals (“we” or “us” or “our”) respects the privacy of
              our users (“user” or “you”). This Privacy Policy explains how we
              collect, use, disclose, and safeguard your information when you
              visit our website Jivafashions.com, including any other media
              form, media channel, mobile website, or mobile application related
              or connected thereto (collectively, the “Site”). Please read this
              privacy policy carefully. If you do not agree with the terms of
              this privacy policy, please do not access the site.
            </p>
            <br></br>
            <p>
              We reserve the right to make changes to this Privacy Policy at any
              time and for any reason. We will alert you about any changes by
              updating the “Last Updated” date of this Privacy Policy. Any
              changes or modifications will be effective immediately upon
              posting the updated Privacy Policy on the Site, and you waive the
              right to receive specific notice of each such change or
              modification.
            </p>
            <br></br>
            <p>
              You are encouraged to periodically review this Privacy Policy to
              stay informed of updates. You will be deemed to have been made
              aware of, will be subject to, and will be deemed to have accepted
              the changes in any revised Privacy Policy by your continued use of
              the Site after the date such revised Privacy Policy is posted.
            </p>
            <br></br>
            <h2>COLLECTION OF YOUR INFORMATION</h2>
            <br></br>
            <p>
              We may collect information about you in a variety of ways. The
              information we may collect on the Site includes:
            </p>
            <br></br>
            <p>Personal Data</p>
            <br></br>
            <p>
              Personally identifiable information, such as your name, shipping
              address, email address, and telephone number, and demographic
              information, such as your age, gender, hometown, and interests,
              that you voluntarily give to us when you register with the Site or
              when you choose to participate in various activities related to
              the Site. You are under no obligation to provide us with personal
              information of any kind, however your refusal to do so may prevent
              you from using certain features of the Site.
            </p>
            <br></br>
            <p>Derivative Data</p>
            <br></br>
            <p>
              Information our servers automatically collect when you access the
              Site, such as your IP address, your browser type, your operating
              system, your access times, and the pages you have viewed directly
              before and after accessing the Site. If you are accesing the Site
              on a mobile device, this information may also include your device
              name and type, your operating system, your phone number, your
              country, and other interactions with the application and other
              users via server log files, as well as any other information you
              choose to provide.
            </p>
            <br></br>
            <p>Financial Data</p>
            <br></br>
            <p>
              Financial information, such as data related to your payment method
              (e.g. valid credit card number, card brand, expiration date) that
              we may collect when you purchase, order, return, exchange, or
              request information about our services from the Site. We store
              only very limited, if any, financial information that we collect.
              Otherwise, all financial information is stored by our payment
              processor, Stripe, and you are encouraged to review their privacy
              policy and contact them directly for responses to your questions.
            </p>
            <br></br>
            <p>Data From Social Networks</p>
            <br></br>
            <p>
              User information from social networking sites such as Facebook,
              including your name, your social network username, location,
              gender, birth date, email address, profile picture, and public
              data for contacts, if you connect your account to such social
              networks.
            </p>
            <br></br>
            <p>Mobile Device Data</p>
            <br></br>
            <p>
              Device information, such as your mobile device ID, model, and
              manufacturer, and information about the location of your device,
              if you access the Site from a mobile device.
            </p>
            <br></br>
            <p>Third-Party Data</p>
            <br></br>
            <p>
              Information from third parties, such as personal information or
              network friends, if you connect your account to the third party
              and grant the Site permission to access this information.
            </p>
            <br></br>
            <p>Mobile Application Information</p>
            <br></br>
            <p>If you connect using our mobile application:</p>
            <br></br>
            <p>
              Geo-Location Information. We may request access or permission to
              and track location-based information from your mobile device,
              either continuously or while you are using our mobile application,
              to provide location-based services. If you wish to change our
              access or permissions, you may do so in your device’s settings.
            </p>
            <br></br>
            <p>
              Mobile Device Data. We may collect device information (such as
              your mobile device ID, model and manufacturer), operating system,
              version information and IP address.
            </p>
            <br></br>
            <p>
              Push Notifications. We may request to send you push notifications
              regarding your account or the Application. If you wish to opt-out
              from receiving these types of communications, you may turn them
              off in your device’s settings.
            </p>
            <br></br>
            <p>
              Push Notifications. We may request to send you push notifications
              regarding your account or the Application. If you wish to opt-out
              from receiving these types of communications, you may turn them
              off in your device’s settings.
            </p>
            <br></br>
            <h2>USE OF YOUR INFORMATION</h2>
            <br></br>
            <p>
              Having accurate information about you permits us to provide you
              with a customized experience. Specifically, we may use information
              collected about you via the Site to:
            </p>
            <ul>
              <li>
                Compile anonymous statistical data and analysis for use
                internally or with third parties.
              </li>
              <li>Create and manage your account.</li>
              <li>
                Deliver targeted advertising, coupons, newsletters, and other
                information regarding promotions and the Site to you.
              </li>
              <li>Email you regarding your account or order.</li>
              <li>
                Fulfill and manage purchases, orders, payments, and other
                transactions related to the Site and our mobile application.
              </li>
              <li>
                Generate a personal profile about you to make future visits to
                the Site more personalized.
              </li>
              <li>Increase the efficiency and operation of the Site.</li>
              <li>
                Monitor and analyze usage and trends to improve your experience
                with the Site.
              </li>
              <li>Notify you of updates to the Site.</li>
              <li>
                Offer new products, services, and/or recommendations to you.
              </li>
              <li>Perform other business activities as needed.</li>
              <li>
                Prevent fraudulent transactions, monitor against theft, and
                protect against criminal activity.
              </li>
              <li>Process payments and refunds.</li>
              <li>
                Request feedback and contact you about your use of the Site.
              </li>
              <li>Resolve disputes and troubleshoot problems.</li>
              <li>Respond to product and customer service requests.</li>
              <li>Send you a newsletter.</li>
              <li>Assist law enforcement and respond to subpoena.</li>
              <li>Solicit support for the Site.</li>
            </ul>
            <br></br>
            <h2>DISCLOSURE OF YOUR INFORMATION</h2>
            <br></br>
            <p>
              We may share information we have collected about you in certain
              situations. Your information may be disclosed as follows:
            </p>
            <br></br>
            <p>By Law or to Protect Rights</p>
            <br></br>
            <p>
              If we believe the release of information about you is necessary to
              respond to legal process, to investigate or remedy potential
              violations of our policies, or to protect the rights, property,
              and safety of others, we may share your information as permitted
              or required by any applicable law, rule, or regulation. This
              includes exchanging information with other entities for fraud
              protection and credit risk reduction.
            </p>
            <br></br>
            <p>Third-Party Service Providers</p>
            <br></br>
            <p>
              We may share your information with third parties that perform
              services for us or on our behalf, including payment processing,
              data analysis, email delivery, hosting services, customer service,
              and marketing assistance.
            </p>
            <br></br>
            <p>Marketing Communications</p>
            <br></br>
            <p>
              With your consent, or with an opportunity for you to withdraw
              consent, we may share your information with third parties for
              marketing purposes, as permitted by law.
            </p>
            <br></br>
            <p>Third-Party Advertisers</p>
            <br></br>
            <p>
              We may use third-party advertising companies to serve ads when you
              visit the Site. These companies may use information about your
              visits to the Site and other websites that are contained in web
              cookies in order to provide advertisements about goods and
              services of interest to you.
            </p>
            <br></br>
            <p>Affiliates</p>
            <br></br>
            <p>
              We may share your information with our affiliates, in which case
              we will require those affiliates to honor this Privacy Policy.
              Affiliates include our parent company and any subsidiaries, joint
              venture partners or other companies that we control or that are
              under common control with us.
            </p>
            <br></br>
            <p>Business Partners</p>
            <br></br>
            <p>
              We may share your information with our business partners to offer
              you certain products, services or promotions.
            </p>
            <br></br>
            <p>Other Third Parties</p>
            <br></br>
            <p>
              We may share your information with advertisers and investors for
              the purpose of conducting general business analysis. We may also
              share your information with such third parties for marketing
              purposes, as permitted by law.
            </p>
            <br></br>
            <p>Sale or Bankruptcy</p>
            <br></br>
            <p>
              If we reorganize or sell all or a portion of our assets, undergo a
              merger, or are acquired by another entity, we may transfer your
              information to the successor entity. If we go out of business or
              enter bankruptcy, your information would be an asset transferred
              or acquired by a third party. You acknowledge that such transfers
              may occur and that the transferee may decline honor commitments we
              made in this Privacy Policy.
            </p>
            <br></br>
            <p>
              We are not responsible for the actions of third parties with whom
              you share personal or sensitive data, and we have no authority to
              manage or control third-party solicitations. If you no longer wish
              to receive correspondence, emails or other communications from
              third parties, you are responsible for contacting the third party
              directly.
            </p>
            <br></br>
            <h2>TRACKING TECHNOLOGIES</h2>
            <br></br>
            <p>Cookies and Web Beacons</p>
            <br></br>
            <p>
              We may use cookies, web beacons, tracking pixels, and other
              tracking technologies on the Site to help customize the Site and
              improve your experience. When you access the Site, your personal
              information is not collected through the use of tracking
              technology. Most browsers are set to accept cookies by default.
              You can remove or reject cookies, but be aware that such action
              could affect the availability and functionality of the Site. You
              may not decline web beacons. However, they can be rendered
              ineffective by declining all cookies or by modifying your web
              browser’s settings to notify you each time a cookie is tendered,
              permitting you to accept or decline cookies on an individual
              basis.
            </p>
            <br></br>
            <p>Internet-Based Advertising</p>
            <br></br>
            <p>
              Additionally, we may use third-party software to serve ads on the
              Site and our mobile application, implement email marketing
              campaigns, and manage other interactive marketing initiatives.
              This third-party software may use cookies or similar tracking
              technology to help manage and optimize your online experience with
              us. For more information about opting-out of interest-based ads,
              visit the Network Advertising Initiative Opt-Out Tool or Digital
              Advertising Alliance Opt-Out Tool.
            </p>
            <br></br>
            <p>Website Analytics</p>
            <br></br>
            <p>
              We may also partner with selected third-party vendors, such as
              Google Analytics and others, to allow tracking technologies and
              remarketing services on the Site through the use of first party
              cookies and third-party cookies, to, among other things, analyze
              and track users’ use of the Site, determine the popularity of
              certain content and better understand online activity. By
              accessing the Site, you consent to the collection and use of your
              information by these third-party vendors. You are encouraged to
              review their privacy policy and contact them directly for
              responses to your questions. We do not transfer personal
              information to these third-party vendors. However, if you do not
              want any information to be collected and used by tracking
              technologies, you can visit the third-party vendor or the Network
              Advertising Initiative Opt-Out Tool or Digital Advertising
              Alliance Opt-Out Tool.
            </p>
            <br></br>
            <p>
              You should be aware that getting a new computer, installing a new
              browser, upgrading an existing browser, or erasing or otherwise
              altering your browser’s cookies files may also clear certain
              opt-out cookies, plug-ins, or settings.
            </p>
            <br></br>
            <h2>THIRD-PARTY WEBSITES</h2>
            <br></br>
            <p>
              The Site may contain links to third-party websites and
              applications of interest, including advertisements and external
              services, that are not affiliated with us. Once you have used
              these links to leave the Site, any information you provide to
              these third parties is not covered by this Privacy Policy, and we
              cannot guarantee the safety and privacy of your information.
              Before visiting and providing any information to any third-party
              websites, you should inform yourself of the privacy policies and
              practices (if any) of the third party responsible for that
              website, and should take those steps necessary to, in your
              discretion, protect the privacy of your information. We are not
              responsible for the content or privacy and security practices and
              policies of any third parties, including other sites, services or
              applications that may be linked to or from the Site.
            </p>
            <br></br>
            <h2>SECURITY OF YOUR INFORMATION</h2>
            <br></br>
            <p>
              We use administrative, technical, and physical security measures
              to help protect your personal information. While we have taken
              reasonable steps to secure the personal information you provide to
              us, please be aware that despite our efforts, no security measures
              are perfect or impenetrable, and no method of data transmission
              can be guaranteed against any interception or other type of
              misuse. Any information disclosed online is vulnerable to
              interception and misuse by unauthorized parties. Therefore, we
              cannot guarantee complete security if you provide personal
              information.
            </p>
            <br></br>
            <h2>POLICY FOR CHILDREN</h2>
            <br></br>
            <p>
              We do not knowingly solicit information from or market to children
              under the age of 13. If you become aware of any data we have
              collected from children under age 13, please contact us using the
              contact information provided below.
            </p>
            <br></br>
            <h2>CONTROLS FOR DO-NOT-TRACK FEATURES</h2>
            <br></br>
            <p>
              Most web browsers and some mobile operating systems include a
              Do-Not-Track (“DNT”) feature or setting you can activate to signal
              your privacy preference not to have data about your online
              browsing activities monitored and collected. No uniform technology
              standard for recognizing and implementing DNT signals has been
              finalized. As such, we do not currently respond to DNT browser
              signals or any other mechanism that automatically communicates
              your choice not to be tracked online. If a standard for online
              tracking is adopted that we must follow in the future, we will
              inform you about that practice in a revised version of this
              Privacy Policy. Most web browsers and some mobile operating
              systems include a Do-Not-Track (“DNT”) feature or setting you can
              activate to signal your privacy preference not to have data about
              your online browsing activities monitored and collected. If you
              set the DNT signal on your browser, we will respond to such DNT
              browser signals.
            </p>
            <br></br>
            <h2>OPTIONS REGARDING YOUR INFORMATION</h2>
            <br></br>
            <p>Account Information</p>
            <br></br>
            <p>
              You may at any time review or change the information in your
              account or terminate your account by:
            </p>
            <br></br>
            <p>Logging into your account settings and updating your account</p>
            <br></br>
            <p>Contacting us using the contact information provided below</p>
            <br></br>
            <p>
              Upon your request to terminate your account, we will deactivate or
              delete your account and information from our active databases.
              However, some information may be retained in our files to prevent
              fraud, troubleshoot problems, assist with any investigations,
              enforce our Terms of Use and/or comply with legal requirements.
            </p>
            <br></br>
            <p>Emails and Communications</p>
            <br></br>
            <p>
              If you no longer wish to receive correspondence, emails, or other
              communications from us, you may opt-out by:
            </p>
            <br></br>
            <p>
              Noting your preferences at the time you register your account with
              the Site. Logging into your account settings and updating your
              preferences.
            </p>
            <br></br>
            <p>Contacting us using the contact information provided below.</p>
            <br></br>
            <p>
              If you no longer wish to receive correspondence, emails, or other
              communications from third parties, you are responsible for
              contacting the third party directly.
            </p>
            <br></br>
            <h2>CALIFORNIA PRIVACY RIGHTS</h2>
            <br></br>
            <p>
              California Civil Code Section 1798.83, also known as the “Shine
              The Light” law, permits our users who are California residents to
              request and obtain from us, once a year and free of charge,
              information about categories of personal information (if any) we
              disclosed to third parties for direct marketing purposes and the
              names and addresses of all third parties with which we shared
              personal information in the immediately preceding calendar year.
              If you are a California resident and would like to make such a
              request, please submit your request in writing to us using the
              contact information provided below.
            </p>
            <br></br>
            <p>
              If you are under 18 years of age, reside in California, and have a
              registered account with the Site, you have the right to request
              removal of unwanted data that you publicly post on the Site. To
              request removal of such data, please contact us using the contact
              information provided below, and include the email address
              associated with your account and a statement that you reside in
              California. We will make sure the data is not publicly displayed
              on the Site, but please be aware that the data may not be
              completely or comprehensively removed from our systems.
            </p>
            <br></br>
            <h2>CONTACT US</h2>
            <br></br>
            <p>
              If you have questions or comments about this Privacy Policy,
              please contact us at:
            </p>
            <br></br>
            <p>Jiva's Originals</p>
            <p>5510 Spine Rd</p>
            <p>Boulder, CO</p>
            <p>80301</p>
            <p>Phone #: 504-616-6756</p>
            <p>jfalconmusik@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
